(() => {
  if (window.CandylandFloatingMascot) return;
  window.CandylandFloatingMascot = true;

  const instances = new WeakSet();

  function toBoolean(value) {
    return value === true || value === 'true';
  }

  function toNumber(value, fallback) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function canUseSessionStorage() {
    try {
      const key = '__floating_mascot_test__';
      sessionStorage.setItem(key, key);
      sessionStorage.removeItem(key);
      return true;
    } catch (error) {
      return false;
    }
  }

  const hasSessionStorage = canUseSessionStorage();

  function getStored(key) {
    if (!hasSessionStorage) return null;
    return sessionStorage.getItem(key);
  }

  function setStored(key, value) {
    if (!hasSessionStorage) return;
    sessionStorage.setItem(key, value);
  }

  function removeStored(key) {
    if (!hasSessionStorage) return;
    sessionStorage.removeItem(key);
  }

  function initFloatingMascot(root) {
    if (!root || instances.has(root)) return;

    const mascot = root.querySelector('[data-floating-mascot]');
    const close = root.querySelector('[data-floating-close]');
    if (!mascot) return;

    instances.add(root);

    const settings = root.dataset;
    const storageKey = settings.floatingStorageKey || `floating-mascot-closed-${settings.sectionId || root.id}`;
    const idleDelay = toNumber(settings.floatingIdleDelay, 2400);
    const autoHideAfter = toNumber(settings.floatingAutoHideAfter, 0);
    const interactionEffect = settings.floatingInteractionEffect || 'none';
    const targetSectionMode = settings.floatingTargetSectionMode || 'all';
    const showMode = settings.floatingShowMode || 'idle';
    const rememberClose = toBoolean(settings.floatingRememberClose);
    const showOnceOnly = toBoolean(settings.floatingShowOnceOnly);
    const rememberInteractionClose = toBoolean(settings.floatingRememberInteractionClose);
    const mobileQuery = window.matchMedia('(max-width: 989px)');

    let idleTimer = null;
    let autoHideTimer = null;
    let hasShown = false;
    let isClosed = false;
    let idleTrackingStarted = false;

    if (rememberClose && showMode !== 'instant' && getStored(storageKey) === 'true') {
      mascot.style.display = 'none';
      isClosed = true;
    }

    mascot.classList.add(`effect-${interactionEffect}`);

    function getTargetElement() {
      if (targetSectionMode === 'all') return document.body;

      if (targetSectionMode === 'candy_swipe') {
        return document.querySelector('[data-section-type="candy-swipe"], .section-candy-swipe-cards');
      }

      if (targetSectionMode === 'homepage') {
        const isHome = document.body.classList.contains('template-index') || window.location.pathname === '/';
        return isHome ? document.body : null;
      }

      if (targetSectionMode === 'product_page') {
        return document.querySelector('main .product, .product, [data-section-type="main-product"]');
      }

      return document.body;
    }

    function isTargetSectionVisible() {
      const target = getTargetElement();
      if (!target) return false;
      if (target === document.body) return true;

      const rect = target.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    }

    function hideMascot(remember) {
      mascot.style.transition = 'opacity .22s ease, transform .22s ease, filter .22s ease';
      mascot.style.opacity = '0';
      mascot.style.transform = 'translate3d(0, 20px, 0) scale(.94)';
      mascot.style.filter = 'blur(4px)';
      isClosed = true;

      if (remember && rememberClose) {
        setStored(storageKey, 'true');
      }

      setTimeout(() => {
        mascot.style.display = 'none';
      }, 240);
    }

    function showMascot() {
      if (showMode === 'instant') {
        isClosed = false;
        removeStored(storageKey);
      }
      if (mobileQuery.matches) return;
      if (isClosed) return;
      if (!isTargetSectionVisible()) return;
      if (hasShown && showOnceOnly) return;

      hasShown = true;
      mascot.hidden = false;
      mascot.style.display = 'block';
      mascot.style.opacity = '';
      mascot.style.filter = '';
      mascot.style.transform = '';
      mascot.classList.remove('is-interacted');

      requestAnimationFrame(() => {
        mascot.classList.add('is-visible');
      });

      if (autoHideAfter > 0) {
        clearTimeout(autoHideTimer);
        autoHideTimer = setTimeout(() => hideMascot(false), autoHideAfter);
      }
    }

    function resetIdleTimer() {
      if (isClosed) return;
      clearTimeout(idleTimer);
      idleTimer = setTimeout(showMascot, idleDelay);
    }

    function handleVisitorActivity() {
      if (isClosed) return;
      if (!idleTrackingStarted) idleTrackingStarted = true;
      resetIdleTimer();
    }

    function interactMascot(event) {
      if (event.target.closest('[data-floating-close]')) return;
      if (interactionEffect === 'none') return;

      mascot.classList.add('is-interacted', 'is-tapped');

      if (interactionEffect === 'pop') {
        setTimeout(() => hideMascot(rememberInteractionClose), 420);
      }

      if (interactionEffect === 'blur' && rememberInteractionClose) {
        setTimeout(() => hideMascot(true), 450);
      }

      if (interactionEffect === 'bounce') {
        setTimeout(() => {
          mascot.classList.remove('is-interacted');
        }, 900);
      }

      if (interactionEffect === 'zoom') {
        setTimeout(() => mascot.classList.remove('is-tapped'), 450);
      }
    }

    ['scroll', 'touchmove', 'wheel', 'keydown', 'pointerdown'].forEach((eventName) => {
      window.addEventListener(eventName, handleVisitorActivity, { passive: true });
    });

    window.addEventListener('scroll', () => {
      if (targetSectionMode === 'all') return;
      if (!isTargetSectionVisible() && mascot.classList.contains('is-visible')) {
        mascot.classList.remove('is-visible');
        mascot.style.display = 'none';
      }
    }, { passive: true });

    if (showMode === 'instant') {
      setTimeout(showMascot, 300);
    } else {
      // Wait for real visitor activity before starting the idle timer.
      // Otherwise the delayed mascot image can become the page LCP element.
    }

    mascot.addEventListener('mouseenter', interactMascot);
    mascot.addEventListener('touchstart', interactMascot, { passive: true });

    if (close) {
      close.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        hideMascot(true);
      });
    }
  }

  function initAllFloatingMascots(root = document) {
    root.querySelectorAll('.floating-mascot-section').forEach(initFloatingMascot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllFloatingMascots());
  } else {
    initAllFloatingMascots();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllFloatingMascots(event.target);
  });
})();
